import apiClient from "./axios";

export const getUsers = async (params?: Record<string, unknown>) =>
  apiClient.get("/users", { params });

export const createAdmin = async (payload: {
  username: string;
  email: string;
  password: string;
}) => apiClient.post("/users", payload);

export const updateUserRole = async (userId: string, role: string) =>
  apiClient.patch(`/users/${userId}/role`, { role });

export const updateUserStatus = async (userId: string, isActive: boolean) =>
  apiClient.patch(`/users/${userId}/status`, { is_active: isActive });

export const updateUserPassword = async (userId: string, password: string) =>
  apiClient.patch(`/users/${userId}/password`, { password });

export const deleteUser = async (userId: string) =>
  apiClient.delete(`/users/${userId}`);
